module.exports = __webpack_public_path__ + "static/media/faculty.a43e7c5d.png";